/* eslint-disable*/
import { get } from '../../utils';
import { getTermFromState } from '../selectors/i18n';
import { getTrimPopularEquippedPrice } from './paymentOptionCalculations';

export const calculateTotalUserAmount = (state) => {
  const downPayment = parseInt(get(state, 'userAmounts.downPayment'), 10) || 0;
  const tradeIn = parseInt(get(state, 'userAmounts.tradeIn'), 10) || 0;
  const accessories = parseInt(get(state, 'userAmounts.accessories'), 10) || 0;
  return (downPayment + tradeIn) - accessories;
};

export const getPaymentOptionUserData = (state, optionType) => {
  const values = get(state, ['bestOffers', 'userValues', optionType]);
  return values || {};
};

export const shouldRenderInlineTrimSelector = (state) => {
  const modelTrimOpen = get(state, 'userAmounts.modelTrimSelectorOpen');
  const nCode = get(state, 'navigation.nCode');
  return (!modelTrimOpen && !nCode);
};

export const getIntelliPriceURL = (state) => {
  const url = getTermFromState(state, 'linkPaths.intellipriceURL');
  const brand = get(state, 'environment.BRAND_CHANNEL');
  const zipCode = get(state, 'dma.zipCode');
  const zipCodeLabel = getTermFromState(state, 'linkPaths.zipCodeAmp');
  let dealerID = 970001;
  if (brand === 'in') {
    dealerID = 975002;
  }
  return `${url}${dealerID}${zipCodeLabel}${zipCode}`
};

export const getUserInputMaxAmount = (state) => {
  const popularEquippedPrice = getTrimPopularEquippedPrice(state);
  const downPayment = parseInt(get(state, 'userAmounts.downPayment'), 10) || 0;
  const tradeIn = parseInt(get(state, 'userAmounts.tradeIn'), 10) || 0;
  const accessories = parseInt(get(state, 'userAmounts.accessories'), 10) || 0;
  const downPaymentMax = (popularEquippedPrice - tradeIn) + accessories;
  const tradeInMax = (popularEquippedPrice - downPayment) + accessories;
  const accessoriesMax = (popularEquippedPrice + downPayment + tradeIn);
  return { downPaymentMax, tradeInMax, accessoriesMax };
};

export const getUserValueFromState = (state, selector) => {
  return parseInt(get(state, `userAmounts.${selector}`), 10) || 0;
};



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/userAmounts.js
 **/